"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DocumentScanPanel;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const pettyCashApi_1 = require("./pettyCashApi");
const AiMetaInfo_1 = require("../../View/CommonComponents/AiMetaInfo");
/**
 * Zdjęcie paragonu albo faktury zamiast przepisywania kwot.
 *
 * `capture="environment"` otwiera na telefonie tylnią kamerę od razu, a na komputerze
 * degraduje się do zwykłego wyboru pliku — więc jeden przycisk obsługuje oba urządzenia.
 *
 * Wynik jest **podpowiedzią**: wpada do pól formularza, które i tak widać w podglądzie
 * arkusza przed zatwierdzeniem. Dlatego komunikat mówi „sprawdź", a nie „gotowe".
 */
function DocumentScanPanel({ onSuggestion, }) {
    const [busy, setBusy] = (0, react_1.useState)(false);
    const [message, setMessage] = (0, react_1.useState)(null);
    const [aiMeta, setAiMeta] = (0, react_1.useState)(null);
    const inputRef = (0, react_1.useRef)(null);
    const handleFile = async (file) => {
        if (!file)
            return;
        setBusy(true);
        setMessage(null);
        setAiMeta(null);
        try {
            const suggestion = await (0, pettyCashApi_1.analyzeDocument)(file);
            onSuggestion(suggestion);
            // Brak zużycia = bramka nie przepuściła tekstu do modelu, więc nic nie kosztowało.
            if (suggestion._model || suggestion._usage)
                setAiMeta({ _model: suggestion._model, _usage: suggestion._usage });
            setMessage(suggestion.recognized
                ? { text: "Uzupełniono z dokumentu — sprawdź kwoty przed zapisem.", ok: true }
                : { text: suggestion.reason ?? "Nie udało się nic odczytać.", ok: false });
        }
        catch (error) {
            setMessage({ text: error.message, ok: false });
        }
        finally {
            setBusy(false);
            // Bez tego wybranie tego samego pliku drugi raz nie wywoła zdarzenia.
            if (inputRef.current)
                inputRef.current.value = "";
        }
    };
    return (react_1.default.createElement("div", { className: "mb-3" },
        react_1.default.createElement("input", { ref: inputRef, type: "file", accept: "image/*,application/pdf", capture: "environment", className: "d-none", onChange: (event) => handleFile(event.target.files?.[0]) }),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", size: "sm", disabled: busy, onClick: () => inputRef.current?.click() },
            busy ? (react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border", className: "me-2" })) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCamera, className: "me-2" })),
            busy ? "Odczytuję…" : "Wypełnij ze zdjęcia dokumentu"),
        message && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: message.ok ? "success" : "warning", className: "py-2 mt-2 mb-0 small" }, message.text)),
        aiMeta && react_1.default.createElement(AiMetaInfo_1.AiMetaInfo, { _model: aiMeta._model, _usage: aiMeta._usage })));
}
